/**
 * Document types filter for search
 */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';

import { Col, FormGroup, Label } from 'design-react-kit';
import { Checkbox } from 'design-comuni-plone-theme/components';

const messages = defineMessages({
  parma_search_for_doc_type: {
    id: 'parma_search_for_doc_type',
    defaultMessage: 'Cerca il tipo di documento',
  },
});

export default function SearchDocTypes({
  docTypes,
  docTypesFilter,
  setDocTypesFilter,
  cols,
}) {
  const intl = useIntl();

  return (
    <>
      {Object.keys(docTypes).map((typeId) => {
        if (docTypes[typeId] === 0) {
          return null;
        }
        return (
          <Col sm={cols ? 12 / cols : 12} key={typeId} className="group-col">
            <FormGroup check tag="div">
              <Checkbox
                id={typeId}
                checked={docTypesFilter === typeId}
                onChange={() =>
                  setDocTypesFilter(typeId === docTypesFilter ? '' : typeId)
                }
                aria-controls="search-results-region"
                aria-label={
                  intl.formatMessage(messages.parma_search_for_doc_type) +
                  ' ' +
                  typeId
                }
              />

              <Label
                check
                for={typeId}
                tag="label"
                className="group-head text-primary"
                widths={['xs', 'sm', 'md', 'lg', 'xl']}
              >
                {typeId}
              </Label>
            </FormGroup>
          </Col>
        );
      })}
    </>
  );
}

SearchDocTypes.propTypes = {
  docTypes: PropTypes.objectOf(PropTypes.number).isRequired,
  docTypesFilter: PropTypes.objectOf(PropTypes.bool).isRequired,
  setDocTypesFilter: PropTypes.func.isRequired,
  cols: PropTypes.number,
};
